import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../generic/CustomBtn';
import { requestApi } from '../../utils/api-request';
import { appStore } from '../../state/app';
import PopUpWrapper from './components/PopUpWrapper';
import RequestModal from '../RequestModal';

const DeleteFieldAgent = ({ showPopUp, setShowPopUp, deleteInfo }) => {
  const { update } = useContext(appStore);
  const translate = useIntl();
  const [reloadError, setReloadError] = useState(false);

  // const fieldAgentName = fieldAgensInfo.field_agent_name;

  const deleteFA = async () => {
    if (deleteInfo?.all) {
      const result = await requestApi('POST', '/api/dashboard/sample-zone/remove-all-field-agents', { project_id: deleteInfo?.idProject });
      if (result !== true) return setReloadError(true);
    } else {
      const result = await requestApi('POST', '/api/dashboard/sample-zone/remove-field-agent', { sample_zone_id: deleteInfo?.sample_zone_id });
      if (result !== true) return setReloadError(true);
    }
    const requestFieldAgentsList = await requestApi('GET', '/api/dashboard/field-agent/list');
    if (requestFieldAgentsList.error) throw new Error(requestFieldAgentsList.error);
    update('app.allFa', requestFieldAgentsList);
    setShowPopUp(!showPopUp);
  };

  const hutOfPopup = () => {
    if (deleteInfo?.all) {
      return (
        <>
          <h3 className="assign__caption">
            {translate.formatMessage({ id: 'popUp.fieldAgents.delete.all' })}
          </h3>
          <p className="assign__text">
            {translate.formatMessage({ id: 'popUp.fieldAgents.delete-warning.all' })}
          </p>
        </>
      );
    }
    return (
      <>
        <h3 className="assign__caption">
          {translate.formatMessage({ id: 'popUp.fieldAgents.delete' })}
        </h3>
        <p className="assign__text">
          {translate.formatMessage({ id: 'popUp.fieldAgents.delete-warning' })}
        </p>
      </>
    );
  };

  return (
    <>
      {reloadError && (
      <RequestModal
        handleClose={() => window.location.reload()}
        title={translate.formatMessage({ id: 'modal.title.oops' })}
        buttonText={translate.formatMessage({ id: 'modal.button.reload' })}
        description={translate.formatMessage({ id: 'modal.title.wentWrong' })}
      />
      )}

      <PopUpWrapper showPopUp={showPopUp} setShowPopUp={setShowPopUp} widthParam="width-640">
        {hutOfPopup()}

        <div className="assign__btn_wrapper">
          <CustomBtn
            label={translate.formatMessage({ id: 'popUp.fieldAgents.delete.btn' })}
            customClass="btn__fa-popup"
            handleClick={deleteFA}
          />
          <CustomBtn
            label={translate.formatMessage({ id: 'popUp.fieldAgents.delete.cancel' })}
            customClass="btn__fa-popup btn__fa-cancel remove"
            handleClick={() => setShowPopUp(!showPopUp)}
          />
        </div>
      </PopUpWrapper>
    </>
  );
};

export default DeleteFieldAgent;
